import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

import './OverflowTip.scss'

/**
 * 文字が収まらないときは書略表示「...」にし、カーソルを合わせると全文をツールチップで表示する
 */
export default class OverflowTip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overflowed: false
    };
    this.textElement = React.createRef();
  }

  componentDidMount() {
    this.setState({
      isOverflowed: this.textElement.current.scrollWidth > this.textElement.current.clientWidth
    });
  }

  render() {
    const { isOverflowed } = this.state;
    return (
      <Tooltip
        title={this.props.children}
        className="ellipsis-tooltip"
        disableHoverListener={!isOverflowed}>
        <div
          ref={this.textElement}
          >
          {this.props.children}
        </div>
      </Tooltip>
    );
  }
}